// frontend/src/api/streamClient.js

const streamClient = {
  post: async (url, data, onData) => {
    const token = localStorage.getItem('access_token'); // Samma nyckel som används i apiClient.js

    // I produktion: relativ URL (samma server)
    // I utveckling: REACT_APP_API_URL eller localhost:5000
    const baseUrl = process.env.NODE_ENV === 'production'
      ? ''
      : (process.env.REACT_APP_API_URL || 'http://localhost:5000');

    const response = await fetch(`${baseUrl}${url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }), // Om token finns, lägg till Authorization-header
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`HTTP-fel! Status: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');

    let done = false;

    while (!done) {
      const { value, done: doneReading } = await reader.read();
      done = doneReading;
      if (value) {
        const chunk = decoder.decode(value);
        onData(chunk);
      }
    }
  },
};

export default streamClient;
